module.exports = __webpack_public_path__ + "static/media/prescription-bottle.36b86dd4.svg";